import Main from './Main.vue'
import Lista from './components/ListaTasks'

export default [{
  path: 'detro-tasks',
  component: Main,
  children: [
    {path: '/', component: Lista, name: 'detro.tasks.list'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/tasks/routes.js